export class FinancialManagementCollections {
  static ModuleName = 'financial-management';

  static invoices = `${FinancialManagementCollections.ModuleName}/invoices`;

  static invoice(invoiceId: string) {
    return `${FinancialManagementCollections.invoices}/${invoiceId}`;
  }

  static invoicePublic(invoiceId: string) {
    return `${FinancialManagementCollections.invoices}/${invoiceId}/public`;
  }

  static invoiceByOrderIdPublic(orderId: string) {
    return `${FinancialManagementCollections.invoices}/by-order/${orderId}/public`;
  }
  static generateQrCode(invoiceId: string) {
    return `${FinancialManagementCollections.invoices}/GenerateQrCode/${invoiceId}`;
  }
}
